export enum BroadcastChannelNames {
  RelativityAuth = 'relativity-oauth',
}

export enum RelativityAuthMessageTypes {
  Success = 'relativity-auth-success',
  Error = 'relativity-auth-error',
}

export interface BroadcastMessage {
  timestamp: number;
}

export interface RelativityAuthMessage extends BroadcastMessage {
  type: RelativityAuthMessageTypes;
  sessionKey: string | null;
}

export interface RelativityAuthSuccessMessage extends RelativityAuthMessage {
  type: RelativityAuthMessageTypes.Success;
}

export interface RelativityAuthErrorMessage extends RelativityAuthMessage {
  type: RelativityAuthMessageTypes.Error;
  error: string | null;
  description: string | null;
}

export type RelativityAuthMessages = RelativityAuthSuccessMessage | RelativityAuthErrorMessage;
